var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9301 22.4674V22.4036C24.9169 22.4251 24.9028 22.4467 24.8887 22.4674H24.9301Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7198 5.63989H8.27924C6.82226 5.63989 5.64062 6.79334 5.64062 8.21491V39.0118C5.64062 40.4327 6.82226 41.5861 8.27924 41.5861H38.7198C40.179 41.5861 41.3606 40.4319 41.3606 39.0118V8.21491C41.3606 6.79262 40.1783 5.63989 38.7198 5.63989ZM16.4676 35.7314H11.0725V19.5H16.4676V35.7314ZM13.7704 17.2828H13.7343C11.9246 17.2828 10.7538 16.0361 10.7538 14.4787C10.7538 12.8865 11.9607 11.6745 13.8058 11.6745C15.6516 11.6745 16.787 12.8865 16.8231 14.4787C16.8231 16.0361 15.6509 17.2828 13.7704 17.2828ZM35.9222 35.7314H30.5272V27.0459C30.5272 24.8647 29.7467 23.3759 27.7946 23.3759C26.3044 23.3759 25.4169 24.3798 25.0259 25.3497C24.8835 25.6959 24.8488 26.1801 24.8488 26.6657V35.7307H19.4538C19.4538 35.7307 19.5246 21.0206 19.4538 19.4993H24.8488V21.7968C25.5658 20.6911 26.8479 19.1163 29.712 19.1163C33.2612 19.1163 35.9229 21.4369 35.9229 26.4229L35.9222 35.7314Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.78c188398e04c4cc7e92b05533c4f09b.svg";
export { ForwardRef as ReactComponent };